import React from 'react';

export default function AllowPermission() {

    return (<div className="allow-permission-container">
        <div className="col-12 text-center">
            <div className="icons"><span className="icon-camera-off" /><span className="icon-mic-off" /></div>
            <div className="info">
                <p>MyBSWHealth needs to use your microphone and camera.</p>
                <hr />
                <p>Select <em><strong>Allow</strong></em> when your browser asks for permissions.</p>
            </div>
        </div>
    </div>);
}